import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import TableHeaderButton from '@/metrics/components/TableHeaderButton/TableHeaderButton'
import { orderByValues } from '@/metrics/hooks/useFilters/constants'

import * as Styles from './styles'

const TableHeader = ({ onSort, orderBy }) => {
  const { t } = useTranslation()

  const isSortingByField = (currentFilter, selectedFilter) => {
    const currentFilterWithoutOrdering = currentFilter?.replace('-', '')

    return currentFilterWithoutOrdering === selectedFilter
  }

  const getDirection = () => {
    return orderBy?.startsWith('-') ? 'desc' : 'asc'
  }

  return (
    <Styles.Container>
      <th />
      <th>
        <Text type="allCapsS">{t('Tienda')}</Text>
      </th>
      <Styles.THAlignRight>
        <TableHeaderButton
          onClick={() => onSort(orderByValues.sales)}
          selected={isSortingByField(orderBy, orderByValues.sales)}
          direction={getDirection()}
          disabled={!onSort}
        >
          <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
            {t('Unidades vendidas')}
          </Text>
        </TableHeaderButton>
      </Styles.THAlignRight>
      <Styles.THAlignRight>
        <TableHeaderButton
          onClick={() => onSort(orderByValues.returns)}
          selected={isSortingByField(orderBy, orderByValues.returns)}
          direction={getDirection()}
          disabled={!onSort}
        >
          <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
            {t('Devoluciones')}
          </Text>
        </TableHeaderButton>
      </Styles.THAlignRight>
      <Styles.THAlignRight>
        <TableHeaderButton
          onClick={() => onSort(orderByValues.ratio)}
          selected={isSortingByField(orderBy, orderByValues.ratio)}
          direction={getDirection()}
          disabled={!onSort}
        >
          <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
            {t('Tasa de devolución')}
          </Text>
        </TableHeaderButton>
      </Styles.THAlignRight>
    </Styles.Container>
  )
}

export default TableHeader
